module.exports = __webpack_public_path__ + "static/media/logPanActive.0dde83a9.svg";